<template>
  <div>
    <main class="main-page anime-cabinet">
      
        <h3 class="username">{{ getUsername() }}</h3>
      <div class="overflow-mobile">
        <div class="kinds">
          <router-link to="/cabinet/favorite">
            <kind-anime :name="'Избранное'" ></kind-anime>
          </router-link>
          <router-link to="/cabinet/watching">
            <kind-anime :name="'Смотрю'"></kind-anime>
          </router-link>
          <router-link to="/cabinet/watched">
            <kind-anime :name="'Просмотрено'"></kind-anime>
          </router-link>
          <router-link to="/cabinet/planned">
            <kind-anime :name="'Запланировано'"></kind-anime>
          </router-link>
          <router-link to="/cabinet/postponed">
            <kind-anime :name="'Отложено'"></kind-anime>
          </router-link>
          <router-link to="/cabinet/droped">
            <kind-anime :name="'Брошено'"></kind-anime>
          </router-link>
        </div>
        
      </div>
      
      <div>
        <animes-count :animes_count="animes_count"></animes-count>
      
        <div class="anime-cards">
          
          <div v-for="anime in animeList" :key="anime.id" class="anime-card">
            <router-link :to="'/' + anime.shikimori_id">
              <div class="img-hidden" :style="{ backgroundImage: 'url(' + (anime.poster_anime ? anime.poster_anime.replace('.me/', '.one/') : '#') + ')', backgroundSize: 'cover' }">
                <span >
                  <img src="@/assets/icons/shikimori_icon.svg">  {{ anime.score ? anime.score  : "0.0" }}
              </span>
              </div>
            </router-link>
            <div class="forMobile">
              <router-link :to="'/' + anime.shikimori_id" :title="anime.title">
                <div class="three-dots h2-monts" >
                  {{ anime.title }}
                </div>
            </router-link>
              <div class="onlyForMobile">
                  
                  <span :class="anime.status === 'ongoing' ? 'blue' : (anime.status === 'anons' ? 'red' : 'green')">{{ getRuStatus(anime.status || '') }}</span>
                <br>
                <p style="margin: 5px 0">{{ getRuKind(anime.kind) }}</p>
              </div>

            </div>
            
            <router-view></router-view>
          </div>
          <div class="content">
            <hr>
            <h3 style="text-align: left;margin-bottom: 0;">Файл со списками аниме, открывается без Интернета</h3>
            <p style="color: lightgrey;margin-top: 0;">Ты можешь сгенерировать файл с твоими аниме списками, чтобы никогда их не потерять. Это оффлайн файл с картинками, который можно просматривать без Интернета. Открывается через любой браузер.</p>
            <div class="generate_offline_anime_list">
              <a style="padding: 10px" :href="generate_anime_path">Генерировать</a>
              
            </div>
            <div class="generate_offline_anime_list">
              <a style="padding: 10px" :href="generate_anime_path_json">Скачать JSON</a>
              
            </div>
            <div class="generate_offline_anime_list">
              <a style="padding: 10px" :href="generate_anime_path_txt">Скачать TXT</a>
              
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import axios from "axios";
import KindAnime from '@/widgets/KindAnime.vue'
import AnimesCount from '@/widgets/AnimesCount.vue'


export default {
  data() {
    return {
      urlBasic: "https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&types=anime,anime-serial",
      animeList: [],
      animeListIs: [],
      searchText: "",
      status: "",
      auth: false,
      generate_anime_path: `${window.location.protocol}//${window.location.hostname}/api/anione_gen.html`,
      generate_anime_path_json: `${window.location.protocol}//${window.location.hostname}/api/anime_list_gen_json.html`,
      generate_anime_path_txt: `${window.location.protocol}//${window.location.hostname}/api/anime_list_gen_txt.html`,
      animes_count: 0
    };
  },
  components: {
    'kind-anime': KindAnime,
    'animes-count': AnimesCount
  },
  watch:{
    $route (to, from){
      this.animeList = [];
      this.changeColorForTabs();
      this.setAnime();
      // this.getAnimesCount();
    }
  },
  mounted(){

  },
  created(){
    localStorage.getItem('scrollY', window.scrollY);
    if(window.location.pathname === '/cabinet/favorite'){
      this.setHeadTitle('Мой кабинет')
    }
    this.auth_hash();
  },
  updated(){
    // this.showAnime();
  },
  methods: {
    auth_hash: function(){
      if(localStorage.getItem('password_hash') && localStorage.getItem('user_id')){
        let url = `${window.location.protocol}//${window.location.hostname}/api/getAnime_list.php?password_hash=${localStorage.getItem('password_hash')}&user_id=${localStorage.getItem('user_id')}`;

        axios
        .get(url)
        .then((response) => {
          if(response.data){
            this.auth = true;
            this.changeColorForTabs();
            this.showAnime();
          }else{
            console.log('Неверный hash и user_id: ' + response.data);
          }
        })
        .catch((error) => {
          alert('Срок сессии истек. Авторизуйтесь заново.')
          console.error(error);
        });
      }else{
      	window.location.pathname = '/'     
      }
    },
    setAnime: function() {
      this.animes_count = 0;
      for (const anime of this.animeListIs) {
        if (window.location.pathname === '/cabinet/favorite' && anime.is_favorite == 1) {
          this.animeList.push(anime);
          this.animes_count++;
        } else if (window.location.pathname === '/cabinet/watched' && anime.state_of_anime === 'watched') {
          this.animeList.push(anime);
          this.animes_count++;
        } else if (window.location.pathname === '/cabinet/watching' && anime.state_of_anime === 'watching') {
          this.animeList.push(anime);
          this.animes_count++;
        } else if (window.location.pathname === '/cabinet/planned' && anime.state_of_anime === 'planned') {
          this.animeList.push(anime);
          this.animes_count++;
        } else if (window.location.pathname === '/cabinet/postponed' && anime.state_of_anime === 'postponed') {
          this.animeList.push(anime);
          this.animes_count++;
        } else if (window.location.pathname === '/cabinet/droped' && anime.state_of_anime === 'droped') {
          this.animeList.push(anime);
          this.animes_count++;
        }
      }
    },
    showAnime: function(){
      if(localStorage.getItem('password_hash') && localStorage.getItem('user_id')){
        let url = `${window.location.protocol}//${window.location.hostname}/api/getAnimeListByUserId.php?password_hash=${localStorage.getItem('password_hash')}&user_id=${localStorage.getItem('user_id')}`;

        axios
        .get(url)
        .then((response) => {
          if(response.data){
            this.animeListIs = response.data;
            this.setAnime();
          }else{
            console.log('Неверный hash и user_id: ' + response.data);
          }
        })
        .catch((error) => {
          alert(error)
          console.error(error);
        });
      }
    },
    changeColorForTabs: function(kind){
      console.log(1);
      let filmsDivs = document.querySelectorAll('.films');
      for(let i = 0;i < filmsDivs.length;i++){
        filmsDivs[i].style.backgroundColor = '#262626';
      }
      if(window.location.pathname === '/cabinet/favorite'){
        filmsDivs[0].style.backgroundColor = '#da8d00'
      }else if(window.location.pathname === '/cabinet/watching'){
        filmsDivs[1].style.backgroundColor = '#6839ff'
      }else if(window.location.pathname === '/cabinet/watched'){
        filmsDivs[2].style.backgroundColor = '#6839ff'
      }else if(window.location.pathname === '/cabinet/planned'){
        filmsDivs[3].style.backgroundColor = '#6839ff'
      }else if(window.location.pathname === '/cabinet/postponed'){
        filmsDivs[4].style.backgroundColor = '#6839ff'
      }else if(window.location.pathname === '/cabinet/droped'){
        filmsDivs[5].style.backgroundColor = '#6839ff'
      }
    },
    searchAnime: function() {
      this.searchText = document.querySelector('.search-anime input').value;
      let url = `https://kodikapi.com/search?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&types=anime,anime-serial&title=${this.searchText}`;
      if(this.searchText === ""){
        url = this.urlBasic;
      }
      axios
        .get(url)
        .then(response => {
          
          this.animeList = response.data.results;

        })
        .catch(error => {
          console.log(error);
        });
    },
    getRuStatus: function(status){
      switch (status) {
        case 'released':
          return 'Вышел';
        case 'ongoing':
          return 'Выходит';
        case 'anons':
          return 'Анонс';
        default:
          return status;
      }
    },
    getRuKind: function(kind){
      switch (kind) {
        case 'tv':
          return 'Сериал';
        case 'movie':
          return 'Фильм';
        case 'special':
          return 'Спэшл';
        default:
          return kind;
      }
    },
    setHeadTitle: function(title) {
      document.querySelector('head title').textContent = title;
    },
    removeDuplicates: function(arr, isSearch = false) {
      const result = [];
      const titles = new Set(); // Создаем пустой Set для хранения уникальных titles
      // Итерируемся по массиву и добавляем объект в результирующий массив,
      // только если его title не был добавлен ранее в Set
      arr.forEach(obj => {
        if (!titles.has(isSearch ? obj.material_data.title : obj.title)) {
          result.push(obj);
          titles.add(isSearch ? obj.material_data.title : obj.title);
        }
      });
      return result;
    },
    getUsername: function(){
      if(localStorage.getItem('username')){
        return localStorage.getItem('username');
      }
    }
  }
};
</script>

<style scoped>
main {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Exo 2", sans-serif;
}
.anime-cards {
  max-width: 1200px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  /* margin: 0 150px; */
}

.h2-monts{
  font-size: 20px;
  font-family: 'Montserrat', sans-serif;
}
.anime-card {
  margin: 1rem;
  flex: 1 0 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.kinds{
  width: 708px;
  margin: 0 5px 0 20px;
}

.overflow-mobile{
  width: 100%;
  overflow-x: auto;
  max-width: 750px;
}
.img-hidden{
    position: relative;
    width: 225px;
    height: 305px;
    border-radius: 8px;
    overflow: hidden;
  }
  

  .main-page .img-hidden span{
    position: absolute;
    background: #3e3e3e; 
    border-radius: 5px;
    padding: 2px 8px;
    bottom: 10px;
    left: 10px;
  /*  right: 10px;*/
  }
  
  .main-page .img-hidden img{
    width: 14px; 
    transform:translateY(1px);
    transition: .5s;
  }
  
  .main-page .img-hidden{
    transition: .3s scale, 3s;
  }
  
  .main-page .img-hidden:hover{
    box-shadow: 0 0 63px 35px #007aff3d;
  }
  
  .main-page .img-hidden img:hover{
    transform:scale(1.3);
  }
  
  .main-page .img-hidden:hover{
  
    transform:scale(1.1);
  }


  .onlyForMobile{
    display: none;
  }
  
  
  .overflow-mobile{
    width: 100%;
    overflow-x: auto;
    max-width: 750px;
  }

.anime-cabinet .overflow-mobile{
  max-width:852px;

}

.anime-cabinet .kinds{
  width: 810px;
}


.anime-cabinet .content{
  max-width: 1200px;
  width: 100%;
  position: relative;
  padding: 20px;
}

.anime-cabinet .generate_offline_anime_list{
  display: inline-block;
  border: 1px solid #5555555e;
  border-radius: 5px;
  background: #2a2a2a99;
  color: white;
  padding: 7px 0;
  margin: 2px 6px 4px 0;
  font-weight: bold;
}


.main-page.anime-cabinet .img-hidden{
  transition: .3s;
}

.forMobile .three-dots{
    margin-top: 15px;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 204px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
  }

/*MOBILE*/

@media only screen and (max-width: 600px) {

  .anime-card{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
  }



  .img-hidden {
    width: 120px;
    height: 155px;
    border-radius: 10px;
    /* opacity: 0.1; */
    background-size: cover;
  }

  .main-page .img-hidden span{
    bottom: 4px;
    left: 2px;
    transform: scale(0.8);
  }

  .forMobile .three-dots{
    margin: 0 0 5px 20px;
    text-align: left;
  }

  .onlyForMobile{
    display: block;
    margin: 0 0 0 20px;
    font-weight: bold;
    color: grey;
  }

  .onlyForMobile img{
    width: 22px;
    transform: translateY(4px);
  }

  .onlyForMobile span{
    margin-right: 10px;
    color: white;
  }

  .onlyForMobile .blue{
    background-color: #0d6efd;
    padding: 3px 5px;
    border-radius: 4px;
  }

  .onlyForMobile .red{
    background-color: red;
    padding: 3px 5px;
    border-radius: 4px;
  }

  .onlyForMobile .green{
    background-color: green;
    padding: 3px 5px;
    border-radius: 4px;
  }
  
}


</style>